import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();

const ITR_UTM_REF = 'itr_2023_organic_landing_page_2';
const startFilingLink = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing?utm_ref=${ITR_UTM_REF}`;
export const startFilingLinkViewPlans = `${publicRuntimeConfig.CLEARTAX_DOMAIN}/filing/?showplan=1&utm_ref=${ITR_UTM_REF}`;
export const cryptoIntegrationLink = `${publicRuntimeConfig.SSO_ENDPOINT}?product=crypto&utm_ref=crypto_itr_2_integration_page&return_path=L2NyeXB0by10YXgtZmlsaW5nL2Jyb2tlcnMv`;

const heroSection = {
  title: 'File ITR for capital gains in minutes ',
  lists: [
    'Simplified/Easy Double Taxation (DTAA) Filing',
    'One-Click Capital Gains Calculation',
    'Fill Schedule FSI & FA in one go',
  ],
  button: [
    {
      text: 'Start filing',
      url: startFilingLink,
    },
    {
      text: 'View plans',
    },
  ],
};

const whyChooseSection = {
  title: 'Why choose ClearTax',
  lists: [
    {
      title: 'Auto-fill of residence & jurisdiction',
      desc: 'Auto-detect & pre-fill residence, jurisdiction, country, and TIN to save time.',
    },
    {
      title: 'Seamless Foreign Asset Reporting ',
      desc: 'Auto-fill Schedule FA by uploading broker statements or transactions.',
    },
    {
      title: 'Auto Currency conversion',
      desc: 'Enter foreign income in USD, we auto-convert to INR for you.',
    },
    {
      title: 'Simplified/Easy Double Taxation (DTAA) Filing',
      desc: 'Fill Schedules FSI & FA together in one seamless form to avoid double taxation.',
    },
  ],
  buttons: [
    {
      text: 'Start FIling',
      url: startFilingLink,
    },
  ],
};
export const ExchangeList = [
  {
    id: '1',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/718342aa-8b15-49d5-9d1a-45d1806e5c1e.png',
    name: 'Upstox',
  },
  {
    id: '2',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/db2e54bb-de91-464e-8814-060c807fc7c3.png',
    name: 'Kite',
  },
  {
    id: '3',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/3bc8bfe5-ea83-404c-b41e-8f5ea8d633e8.png',
    name: 'Groww',
  },
  {
    id: '4',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/4b73f019-0e78-4e20-a1c8-4b0798130b54.png',
    name: 'ICICI Direct',
  },
  {
    id: '5',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/e8ce47b3-1f4c-48c8-aece-129ab4c098ff.png',
    name: 'Paytm Money',
  },
  {
    id: '6',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/bb34b676-c260-4564-8789-353fa5cb6237.png',
    name: 'SBI Caps',
  },
  {
    id: '7',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/1a4f9afc-2d8e-4289-9190-04eed9f7a244.png',
    name: 'Kotak',
  },
  {
    id: '8',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/a965c566-85b4-4d76-b10a-687be311c652.png',
    name: 'Axis Securities',
  },
  {
    id: '9',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/734b28d5-91cf-4d68-8382-82209468c896.png',
    name: 'Reliance Securities',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/d37ab44c-70e2-493b-8bbc-eed9dcc53534.png',
    name: 'Zerodha',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/5937fd37-48df-404b-be2e-ed89f99e3a12.png',
    name: 'HDFC Securities',
  },
];

export const ExchangeList2 = [
  {
    id: '1',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108712_wazirx_logo.png',
    name: 'WazirX',
  },
  {
    id: '2',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109419_coindcx_logo.png',
    name: 'CoinDCX',
  },
  {
    id: '3',
    icon: 'https://assets1.cleartax-cdn.com/taxengine-crypto/images/1682491670_coinswitch.svg',
    name: 'CoinSwitch',
  },
  {
    id: '4',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109376_binance_logo.png',
    name: 'Binance',
  },
  {
    id: '5',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109827_coinbase_logo.png',
    name: 'Coinbase',
  },
  {
    id: '6',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109384_bitbns_logo.png',
    name: 'BitBNS',
  },
  {
    id: '7',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108721_zebpay__logo.png',
    name: 'Zebpay',
  },
  {
    id: '8',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108642_metamask_logo.png',
    name: 'Metamask',
  },
  {
    id: '9',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675109568_etherium_logo.png',
    name: 'Etherium',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108612_kucoin_logo.png',
    name: 'KuCoin',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108657_solana_logo.png',
    name: 'Solana',
  },
  {
    id: '10',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108612_kucoin_logo.png',
    name: 'KuCoin',
  },
  {
    id: '11',
    icon: 'https://assets1.cleartax-cdn.com/cleartax/images/1675108657_solana_logo.png',
    name: 'Solana',
  },
];

export const itrData = {
  heroSection,
  isVariant: false,
  whyChooseSection,
};

export const GuidesAndLinksDataITR2 = {
  heading: 'Guides and useful links to help you Efile taxes',
  cards: [
    {
      label: 'Income Tax for NRIs',
      description: `NRIs are taxed in India only on income earned or accrued within India. They can choose between the old and new tax regimes and must file an ITR if Indian income exceeds the basic exemption limit.`,
      link: 'https://cleartax.in/s/income-tax-for-nri',
    },
    {
      label: 'NRI Residency Status',
      description: `The taxable income is based on the residential status of the taxpayers. Learn how a taxpayer is classified as an NRI and the taxation of NRIs income.`,
      link: 'https://cleartax.in/s/nri-status-and-taxation',
    },
    {
      label: 'Set off & carry forward capital losses',
      description: `Understand how to treat capital losses and adjust them against gains to reduce taxable income.`,
      link: 'https://cleartax.in/s/set-off-carry-forward-capital-losses',
    },
    {
      label: 'Income tax filing for capital gains',
      description: `ClearTax has integrations with 80+ brokers, enabling one-click fetching of capital gains data.`,
      link: 'https://cleartax.in/s/itr2',
    },
    {
      label: 'Long-term Capital Gains',
      description: `Gains from the transfer of long-term capital assets (held for more than either 12 or 24 months, as applicable) are known as long-term capital gains.`,
      link: 'https://cleartax.in/s/long-term-capital-gains-ltcg-tax',
    },
    {
      label: 'Short-term Capital Gains',
      description: `Gains from the transfer of short-term capital assets (held for less than either 12 or 24 months, as applicable) are known as short-term capital gains. `,
      link: 'https://cleartax.in/s/short-term-capital-gains-stcg-tax',
    },
    {
      label: 'Which ITR to file?',
      description: `NRIs usually use ITR-2 and ITR-3 for filing their tax returns. Learn the applicability of these ITR forms, the eligibility criteria and which ITR form is applicable.`,
      link: 'https://cleartax.in/s/which-itr-to-file',
    },
    {
      label: 'What Is ITR-3?',
      description: `Taxpayers with business income exceeding Rs. 50 lakh need to file Form ITR-3. Learn the applicability of ITR-3.`,
      link: 'https://cleartax.in/s/itr3',
    },
  ],
};

export const ITR_2_FAQs = [
  {
    header:
      "Is there any penalty if I don't declare my foreign income in my ITR?",
    content: (
      <>
        <p>
          Yes, if you fail to declare foreign income, you may face penalties
          under Section 270A for underreporting or misreporting income. The
          penalty can range from 50% to 200% of the tax payable on the
          underreported income.
          <br />
          Additionally, failing to disclose foreign assets can lead to penalties
          under Section 285BA for non-compliance with the Foreign Account Tax
          Compliance Act (FATCA) requirements.
        </p>
      </>
    ),
  },
  {
    header:
      ' I am based out of Dubai. I got ESOPs from the parent company based in India, how do I report it?',
    content: (
      <p>
        It is taxed twice, when you exercise it, it will be taxed as salary. But
        when you sell it, it will be taxed as capital gains.
      </p>
    ),
  },
  {
    header:
      'Can I claim deductions for my foreign income or foreign taxes paid?',
    content: (
      <p>
        Yes, you can claim deductions under Section 80C, 80D, and other
        applicable sections. Additionally, you can claim a Foreign Tax Credit
        (FTC) for taxes paid on foreign income.
      </p>
    ),
  },
  {
    header: ' Do I need to convert my foreign income to INR for tax filing?',
    content: (
      <p>
        Yes, foreign income should be converted to INR using the applicable
        exchange rate on the date of receipt or accrual, as per the Income Tax
        Department guidelines.
      </p>
    ),
  },
  {
    header:
      'What is the process for filing my ITR as an NRI with multiple foreign incomes?',
    content: (
      <p>
        You’ll need to report each source of foreign income (e.g., salary,
        rental income, dividends) separately in the appropriate sections. If you
        have income from multiple countries, you can claim relief under the
        Double Tax Avoidance Agreement (DTAA) if applicable.
      </p>
    ),
  },
];
